import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryProps } from './ErrorBoundary';
import ErrorFallback from '../ErrorFallback/ErrorFallback';

/* eslint-disable @typescript-eslint/no-explicit-any*/
export const ErrorBoundary = ({ children, ...props }: ErrorBoundaryProps): any => {
    return (
        <ReactErrorBoundary FallbackComponent={ErrorFallback} {...props}>
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;
